import React from "react";
import { TextInput, Select, SelectOption } from "@justworkshr/milo-form";
import { getIn, useFormikContext } from "formik";
import {
  ContactInfoFormType,
  InternationalAddressInputType,
} from "../../onboarding/contact-info/types";
import { Zone } from "@shopify/address-consts";
import { SupportedCountriesData } from "../../contexts/supportedCountriesContext";
import { useTranslation } from "react-i18next";
import { InternationalAddressInput } from "types/generated/operations";

type Props = {
  fieldName: keyof InternationalAddressInput;
  handleBlur: (event: React.FocusEvent) => void;
  handleChange: (event: React.ChangeEvent) => void;
  zones: Zone[] | undefined;
  formPath: string;
  supportedCountriesData: SupportedCountriesData;
};

const fieldTypeMap: InternationalAddressInputType = {
  countryCode: "select",
  address1: "text",
  address2: "text",
  city: "text",
  postalCode: "text",
  zoneCode: "select",
};

const AddressFieldElement = ({
  fieldName,
  handleChange,
  handleBlur,
  zones,
  formPath,
  supportedCountriesData,
}: Props) => {
  const { t } = useTranslation();
  const { values } = useFormikContext<ContactInfoFormType>();
  const address = getIn(values, formPath) as InternationalAddressInput;
  const type = fieldTypeMap[fieldName];

  switch (type) {
    case "text":
      return (
        <TextInput
          id={`${formPath}.${fieldName}`}
          name={`${formPath}.${fieldName}`}
          onChange={handleChange}
          onBlur={handleBlur}
          value={address[fieldName] ?? ""}
        />
      );
    case "select":
      if (fieldName === "countryCode") {
        return (
          <Select
            id={`${formPath}.${fieldName}`}
            name={`${formPath}.${fieldName}`}
            onChange={handleChange}
            onBlur={handleBlur}
            placeholder={
              address[fieldName].length > 0 ? undefined : t("Select one")
            }
            value={address[fieldName] ?? ""}
          >
            {Object.values(supportedCountriesData).map((country) => {
              const translatedName = country.commonName
                ? t(country.commonName)
                : "";
              return (
                <SelectOption value={country.code} key={country.code}>
                  {country.emojiFlag + " " + translatedName}
                </SelectOption>
              );
            })}
          </Select>
        );
      }

      if (fieldName === "zoneCode") {
        return (
          <Select
            id={`${formPath}.${fieldName}`}
            name={`${formPath}.${fieldName}`}
            onChange={handleChange}
            onBlur={handleBlur}
            placeholder={
              address[fieldName].length > 0 ? undefined : t("Select one")
            }
            value={address[fieldName] ?? ""}
          >
            {zones?.map((zone) => (
              <SelectOption value={zone.code} key={zone.code}>
                {zone.name}
              </SelectOption>
            ))}
          </Select>
        );
      }
      break;
  }

  return null;
};

export default AddressFieldElement;
